import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { first } from 'rxjs/operators';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import {
  AuthenticationService,
  ConfirmPasswordValidator,
} from '@app/_services';

@Component({
  selector: 'app-activate-account',
  templateUrl: './activate-account.component.html',
  styleUrls: ['./activate-account.component.css'],
})
export class ActivateAccountComponent implements OnInit {
  passwordResetForm: FormGroup;
  loadingSubmit = false;
  submitted = false;
  returnUrl: string;
  passwordVisible1 = false;
  passwordVisible2 = false;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private http: HttpClient
  ) {
    // redirect to home if already logged in
    // if (this.authenticationService.currentUserValue) {
    //this.router.navigate(['/']);
    // }
    this.authenticationService.logout();
  }

  ngOnInit() {
    this.passwordResetForm = this.formBuilder.group(
      {
        password: [null, [Validators.required]],
        verifyPassword: [null, [Validators.required]],
        key: [null],
        email: [null],
        activateAccount: [1],
      },
      {
        validator: ConfirmPasswordValidator('password', 'verifyPassword'),
      }
    );

    // get return url from route parameters or default to '/'
    //this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  onSubmit() {
    this.submitted = true;

    for (const i in this.passwordResetForm.controls) {
      this.passwordResetForm.controls[i].markAsDirty();
      this.passwordResetForm.controls[i].updateValueAndValidity();
    }

    if (this.passwordResetForm.invalid) {
      return;
    }

    this.route.queryParams.subscribe((params) => {
      this.passwordResetForm.controls['key'].setValue(params['key']);
      this.passwordResetForm.controls['email'].setValue(params['email']);
    });

    this.loadingSubmit = true;
    this.authenticationService
      .passwordreset(this.passwordResetForm.value)
      .pipe(first())
      .subscribe({
        next: () => {
          this.router.navigate(['../login'], { relativeTo: this.route });
        },
        error: (error) => {
          console.log(error);
          this.loadingSubmit = false;
        },
      });
  }
}
